import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import TargetLabel from '../Target';
import HeldSVG from '../../../../images/sales-stream/ticketgraph.svg';

const useStyles = makeStyles({
  chart: {
    display: 'flex',
    flexDirection: 'row',
    gap: '15px',
    justifyContent: 'start',
    alignItems: 'center',
  },
  bar: {
    backgroundImage: `url(${HeldSVG})`,
    backgroundRepeat: 'repeat-x', // Repeat horizontally
    backgroundSize: 'auto 100%', // Ensure SVG fits the height of the bar
    backgroundPosition: '0 0', // Align the SVG pattern at the start
    backgroundColor: 'transparent',
    border: 'none',
    position: 'relative',
    overflow: 'hidden',
    transition: 'width 0.5s ease',
    marginTop: '5px',
  },
  barLabel: {
    position: 'absolute',
    bottom: '0',
    left: '0',
    right: '0',
    textAlign: 'center',
    fontSize: '14px',
    padding: '5px',
    color: '#333',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
  },
});

const HeldChart = props => {
  const { percentage, showLabel, target } = props;
  const classes = useStyles();

  return (
    <div className={classes.chart}>
      <div className={classes.bar} style={{ width: `${percentage}%`, height: '25px' }} />
      {showLabel && <TargetLabel target={target} />}
    </div>
  );
};

HeldChart.propTypes = {
  percentage: PropTypes.number.isRequired,
  showLabel: PropTypes.bool.isRequired,
  target: PropTypes.number.isRequired,
};

export default HeldChart;
